import Crud from './crud'
var crud = new Crud('orders', 'đơn hàng');

const state = {
    ...crud.state,
    new: {},
    sale: {},
    selected: {
        id: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
};
const mutations = {
    ...crud.mutations,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};